import React from "react";
import { Link } from "react-router-dom";
import "../styles/ExtraStyles.css";
import strawberry from "../assets/strawberry.png";

const NotFound = () => {
    return (
        <>
            <title>404 - Siden ble ikke funnet | Wildberries</title>
            <meta name="description" content="Oops! Siden du leter etter finnes ikke. Gå tilbake til forsiden for å finne friske bær!" />
            <meta property="og:title" content="404 - Siden ble ikke funnet | Wildberries" />
            <meta property="og:description" content="Vi finner ikke denne siden. Klikk her for å gå tilbake til Wildberries!" />

            
            <div className="berry-404-container">
                <h1 className="berry-404-text">404</h1>
                <p className="berry-404-message">Oops! Vi fant ikke siden du leter etter</p>
                <img className="berry-404-image" src={strawberry} alt="Jordbær" />
                <Link to="/">
                    <button className="berry-404-button">Tilbake til forsiden</button>
                </Link>
            </div>
        </>
    );
};

export default NotFound;
